import {
    IonButton,
    IonButtons,
    IonChip,
    IonContent,
    IonHeader,
    IonIcon,
    IonItem,
    IonLabel,
    IonList,
    IonListHeader,
    IonModal,
    IonSearchbar,
    IonText,
    IonTitle,
    IonToolbar,
} from "@ionic/react";
import { closeOutline } from "ionicons/icons";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { selectUserProfileLocationFilters } from "../../../store/userProfileLocation/selector/selectUserProfileLocationFilters";
import { selectBusinessAreaList } from "../../../store/userProfileLocation/selector/selectBusinessAreaList";
import { setBusinessArea } from "../../../store/userProfileLocation";

export const LocationsSelectoBusinessAreaFilter = () => {
    const dispatch = useDispatch();
    const createFilters = useSelector(selectUserProfileLocationFilters);
    const businessAreaList = useSelector(selectBusinessAreaList);
    const [showFilterModal, setShowFilterModal] = useState(false);
    const [listSearchtext, setListSearchtext] = useState("");

    return (
        <section>
            <IonChip
                onClick={() => setShowFilterModal(true)}
                outline
                color={createFilters.businessArea ? "primary" : "medium"}
            >
                <IonLabel class="ion-text-nowrap">
                    {createFilters.businessArea?.id ? (
                        <IonText color="primary" style={{ fontWeight: 600 }}>
                            <span>Area de negocio: </span>
                            {createFilters.businessArea?.name}
                        </IonText>
                    ) : (
                        <span>Area de negocio: Todos</span>
                    )}
                </IonLabel>
            </IonChip>
            {/* Ventana de seleccion de Área de negocio */}
            <IonModal isOpen={showFilterModal} onDidDismiss={() => setShowFilterModal(false)}>
                <IonHeader>
                    <IonToolbar>
                        <IonTitle>Filtrar por area de negocio</IonTitle>
                        <IonButtons slot="end">
                            <IonButton onClick={() => setShowFilterModal(false)}>
                                <IonIcon icon={closeOutline} />
                            </IonButton>
                        </IonButtons>
                    </IonToolbar>
                </IonHeader>
                <IonContent>
                    <IonSearchbar
                        value={listSearchtext}
                        onIonChange={({ detail: { value = "" } }) => {
                            setListSearchtext(value);
                        }}
                        debounce={900}
                        placeholder="Buscar"
                    />
                    <IonList>
                        <IonListHeader>Clientes</IonListHeader>
                        {businessAreaList
                            .filter(({ name }) => name?.toLowerCase().includes(listSearchtext.toLowerCase()))
                            .map((businessArea, index: number) => (
                                <IonItem
                                    key={index}
                                    onClick={() => {
                                        console.log("Selecciona Area de negocio")
                                        dispatch(setBusinessArea(businessArea));
                                        setShowFilterModal(false);
                                    }}
                                    button
                                    detail
                                >
                                    <IonLabel>{businessArea.name}</IonLabel>
                                </IonItem>
                            ))}
                    </IonList>
                </IonContent>
            </IonModal>
        </section>
    );
}